export default __webpack_public_path__ + "img/bGKcJYkx.cc1932ba.svg";